<template>
  <StandardCardContainer radius="small" v-if="allSenders.length > 0">
    <div v-if="allSenders.length > 0">
      <v-row justify="center">
        <v-col cols="2">
          <div
            style="
              background-color: var(--light-tangerine-4);
              height: 58px;
              width: 58px;
              border-radius: 50%;
              text-align: center;
            "
          >
            <AppkitIcon
              icon="icon-survey-checkmark-outline"
              size="xl"
              class="mt-4 mr-3"
              style="color: var(--tangerine)"
            />
          </div>
        </v-col>
        <v-col class="text-left mt-4">
          <p>You have pending requests from:</p>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="6" class="text-left">
          <ul>
            <li v-for="sender in allSenders">{{ sender }}</li>
          </ul>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-right">
          <PActionButton
            :append-icon="true"
            :icon-size="'xs'"
            appkit-icon="icon-right-chevron-fill"
            @click="routeToQuestionnaires"
            >Go to questionnaires
          </PActionButton>
        </v-col>
      </v-row>
    </div>
  </StandardCardContainer>
  <StandardCardContainer v-else radius="small">
    <v-row justify="center" class="mb-2 mt-1">
      <v-col cols="2">
        <AppkitIcon
          icon="icon-circle-checkmark-fill"
          size="xl"
          class="mt-4"
          style="color: var(--light-status-green)"
        />
      </v-col>
      <v-col class="text-left mt-4">
        <p>You have completed all tasks.</p>
      </v-col>
    </v-row>
  </StandardCardContainer>
</template>

<script setup lang="ts">
import AppkitIcon from "@/components/custom/AppkitIcon.vue";
import PActionButton from "@/components/custom/buttons/PActionButton.vue";
import { computed } from "vue";
import { AnswerStatus } from "@/models/enum/answerStatus";
import { ForwardingStatus } from "@/models/enum/forwardingStatus";
import { useRouter } from "vue-router";
import type ReceivedQuestionnaires from "@/models/receivedQuestionnaires";
import StandardCardContainer from "@/components/containers/StandardCardContainer.vue";

const router = useRouter();

const props = defineProps<{
  receivedQuestionnaires: ReceivedQuestionnaires;
}>();

const allSenders = computed(() => {
  const allSenderCompanies = props.receivedQuestionnaires.questionnaires
    .filter(
      (q) =>
        q.answerStatus != AnswerStatus.Completed ||
        q.forwardingStatus != ForwardingStatus.Completed
    )
    .flatMap((q) => q.senderCompanies);
  return [...new Set(allSenderCompanies)];
});

function routeToQuestionnaires() {
  router.push({
    name: "questionnaires",
    params: { initialTab: "new-questionnaires" },
  });
}
</script>
